import { render, staticRenderFns } from "./SearchBook.vue?vue&type=template&id=a81a3864&"
import script from "./SearchBook.vue?vue&type=script&lang=ts&"
export * from "./SearchBook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports